import type { GetCurrentUserOutputDTO } from '@/shared/types/api/getCurrentUserOutputDTO';
import { TermsAcceptanceStatusType } from '@/shared/types/api/termsAcceptanceStatusType';

export function userRequiresTermsAcceptance(user: GetCurrentUserOutputDTO): boolean {
  return user.terms_acceptance_status !== TermsAcceptanceStatusType.ACCEPTED;
}
